import validate from "/codefresh/volume/ybd/node_modules/nuxt/dist/pages/runtime/validate.js";
import setup_45global from "/codefresh/volume/ybd/ui/portal/src/middleware/setup.global.ts";
import manifest_45route_45rule from "/codefresh/volume/ybd/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  setup_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}